import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Motion from "framer-motion";
import "../CSS/Contact.css";
import doubleArrow from "../Resources/Images/DoubleArraw.svg";


const Contact: React.FC = () => {
  return (
    <div className="htmlOverflow">
      <section className="contactPage">
        <div className="contactPageSection">
          <p className="mainTopic">Your <br></br>Thoughts Matter</p>
          <p className="subTopic">I'm just a message away! Whether it's feedback, inquiries, or collaboration, I'm eager to hear from you.
          </p>
          <div className="contactMeShortCut">
            <img src={doubleArrow} alt="Arrows" />
            <Link to="/contact">Get Started</Link>
          </div>
        </div>
      </section>

      <section className="about">
        <div className="boarderCenter">
          <p className="aboutTopic">Gerald Fernand0</p>
        </div>
      </section>
</div>
  );
};

export default Contact;